export const profile = {
  Edit_your_profile: "Edite su perfil",
  Logout: "Cerrar sesión",
  Profile: "Perfil",
  language: "Idioma",
} as const;
